import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuei18n from "vue-i18n";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import md5 from 'js-md5';
import axios from 'axios'

import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

Vue.use(VueVirtualScroller)

Vue.prototype.$md5 = md5;
Vue.config.productionTip = false
Vue.use(Vuei18n);

const i18n = new Vuei18n({
    locale: 'en-US',
});
window.i18n = i18n
    //从utils库内获取多语言文件，并配置
let messages = {
    'zh-CN': '/json/zh_CN.json',
    'en-US': '/json/en_US.json',
    'zh-TW': '/json/zh_HK.json',
    'zh-HK': '/json/zh_HK.json',
    'ko-KR': '/json/ko_KR.json',
    'id-ID': '/json/id_ID.json',
    'ja-JP': '/json/ja_JP.json',
    'vi-VN': '/json/vi_VN.json',
    'th-TH': '/json/th_TH.json',
    'ru-RU': '/json/ru_RU.json',
}
let promiseArr = []
Object.keys(messages).map(lang => {
    promiseArr.push(axios({
        url: CONFIG.utilsUrl + messages[lang],
        data: {lang}
    }))
})
const p = Promise.all(promiseArr)
p.then(res => {
    res.forEach(i => {
        const lang = JSON.parse(i.config.data).lang
        window.i18n.setLocaleMessage(lang, i.data)
    })
    store.commit('INIT',{
        showPage: true
    })
})
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});
setTimeout(() => {
    new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
    }).$mount('#app')
}, 500)